import { BudgetCategoryGroupFieldsFragment } from '../../graphql/generated';

// Creates a map of category group IDs to their budget category groups
export const buildBudgetCategoryGroupMap = (
    budgetCategoryGroups: BudgetCategoryGroupFieldsFragment[]
) =>
    budgetCategoryGroups.reduce<
        Record<string, BudgetCategoryGroupFieldsFragment | undefined>
    >((acc, budgetCategoryGroup) => {
        acc[budgetCategoryGroup.categoryGroup.id] = budgetCategoryGroup;
        return acc;
    }, {});
